import { stylesFactory } from '@orthly/ui-primitives';

export const useOrderSummaryRowButtonStyles = stylesFactory(() => ({
    button: {
        padding: '2px 12px',
        height: 'unset',
    },
}));
